import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const CheckDouble: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[20px] h-[20px] stroke-[2px]', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M18.8046 5.36177C19.0649 5.62212 19.0649 6.04423 18.8046 6.30458L10.4712 14.6379C10.2109 14.8983 9.78878 14.8983 9.52843 14.6379L5.36177 10.4712C5.10142 10.2109 5.10142 9.78878 5.36177 9.52843C5.62212 9.26808 6.04423 9.26808 6.30458 9.52843L9.99984 13.2237L17.8618 5.36177C18.1221 5.10142 18.5442 5.10142 18.8046 5.36177Z" fill="inherit" />
    <path fillRule="evenodd" clipRule="evenodd" d="M14.6381 5.36177C14.8984 5.62212 14.8984 6.04423 14.6381 6.30458L10.4714 10.4712C10.2111 10.7316 9.78895 10.7316 9.5286 10.4712C9.26825 10.2109 9.26825 9.78878 9.5286 9.52843L13.6953 5.36177C13.9556 5.10142 14.3777 5.10142 14.6381 5.36177ZM1.19526 9.52843C1.45561 9.26808 1.87772 9.26808 2.13807 9.52843L6.30474 13.6951C6.56509 13.9555 6.56509 14.3776 6.30474 14.6379C6.04439 14.8983 5.62228 14.8983 5.36193 14.6379L1.19526 10.4712C0.934913 10.2109 0.934913 9.78878 1.19526 9.52843Z" fill="inherit" />
  </svg>
);

export default CheckDouble;
